export const facilityListDataTableHeaders = [
  {
    text: "Actions...",
    sortable: false,
    value: "actions",
    width: "80px"
  },
  {
    text: "Loc. Code",
    value: "location_code",
    width: "100px"
  },
  {
    text: "Facility Name",
    value: "name",
    width: "200px"
  },
  {
    text: "Distance",
    value: "distance",
    sortable: false
  },
  {
    text: "Street Address",
    value: "street_address",
    width: "200px"
  },
  {
    text: "City",
    value: "city"
  },
  {
    text: "State",
    value: "state"
  },
  {
    text: "Zip",
    value: "postal_code"
  },
  {
    text: "Phone",
    value: "phone",
    width: "100px"
  }
];
